type PropsType = {
  phoneNumber: string
}

const PhoneNumberContainer = (props: PropsType) => {
  return (
    <p className="text-center mx-auto w-full text-[#2D2D41] font-semibold text-base leading-9">
      {props.phoneNumber}
    </p>
  )
}

export default PhoneNumberContainer
